import React from 'react';
import PropTypes from 'prop-types';

const Spinner = () => (
    <svg className="offers-v4-sticky-cta__spinner" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="3" strokeDasharray="32.99" strokeDashoffset="11" strokeLinecap="round" />
    </svg>
);

const OffersV4StickyCta = ({ onContinue, disabled, loading }) => (
    <div className="offers-v4-sticky-cta">
        <p className="offers-v4-sticky-cta__disclaimer">
            Selecting an offer isn't a commitment to a loan.
        </p>
        <button
            id="offers-v4-select-offer"
            className={`offers-v4-sticky-cta__button${loading ? ' offers-v4-sticky-cta__button--loading' : ''}`}
            onClick={disabled ? undefined : onContinue}
            aria-disabled={disabled}
            aria-busy={loading}
            type="button"
        >
            {loading && <Spinner />}
            {loading ? 'Loading' : 'Continue with this offer'}
        </button>
    </div>
);

OffersV4StickyCta.propTypes = {
    onContinue: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
};

OffersV4StickyCta.defaultProps = {
    disabled: true,
    loading: false,
};

export default OffersV4StickyCta;
